import { DialogObject } from '@/components/dialog/dialog.types';
import { FormBuilderComponent } from '@/components/form-builder/form-builder.component';
import { FieldVariant, FileFieldProps, DynamicField, CustomFieldProps } from '@/components/form-builder/form-builder.types';
import { PreviewPdfComponent } from '@/components/shared/preview-pdf/preview-pdf.component';
import { MeetingRepository } from '@/store/meeting-state/meeting-state.repository';
import { FileRemoveEvent, FileSelectEvent } from 'primeng/fileupload';
import { finalize, map, of, switchMap } from 'rxjs';

interface IGetSnippetPVUploadDialogProps {
  store: MeetingRepository;
  validate: () => void;
}

export const getSnippetPVUploadDialog = ({ store, validate }: IGetSnippetPVUploadDialogProps): DialogObject => {
  let currentObjectUrl: string | null = null;

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  let uploaderReset: () => void = () => {};
  const fileField: DynamicField<FileFieldProps> = {
    label: 'Extrait PV',
    variant: FieldVariant.FILE,
    isRequired: true,
    props: {
      mode: 'basic',
      accept: 'application/pdf',
      multiple: false,
      value: store.getNestedObservable<File[]>('upload', 'snippetFile'),
      onFileSelect: (event: FileSelectEvent) => {
        store.setNested('upload', 'snippetFile', event.currentFiles);
      },
      onFileRemoved: (event: FileRemoveEvent) => {
        store.setNested(
          'upload',
          'snippetFile',
          store.getNested<File[]>('upload', 'snippetFile').filter(file => file.name !== event.file.name)
        );
      },
      setResetMethod: (fn: () => void) => {
        uploaderReset = fn;
      },
      message: 'common.files.warn',
    },
  };
  const filePreviewField: DynamicField<CustomFieldProps> = {
    label: 'Aperçu du fichier',
    variant: FieldVariant.CUSTOM,
    isHidden: store.getNestedObservable<File[]>('upload', 'snippetFile').pipe(map((files: File[]) => !files || files.length === 0)),
    props: {
      component: PreviewPdfComponent,
      injectKeys: ['src'],
      src: store.getNestedObservable<File[]>('upload', 'snippetFile').pipe(
        switchMap((files: File[]) => {
          if (currentObjectUrl) {
            URL.revokeObjectURL(currentObjectUrl);
            currentObjectUrl = null;
          }

          if (!files || files.length === 0) {
            return of('');
          }

          const file = files[0];
          const url = URL.createObjectURL(file);
          currentObjectUrl = url;
          return of(url);
        }),
        finalize(() => {
          if (currentObjectUrl) {
            URL.revokeObjectURL(currentObjectUrl);
            currentObjectUrl = null;
          }
        })
      ),
    },
  };

  return {
    title: 'Télécharger Extrait Signé',
    actions: [
      {
        label: 'meeting.actions.upload',
        variant: 'success',
        onClick: () => validate(),
      },
    ],
    onHide: () => {
      store.setNested('upload', 'snippetFile', null);
      uploaderReset();
    },
    width: '80%',
    component: {
      outlet: FormBuilderComponent,
      props: {
        formObject: {
          title: '',
          description: '',
          isHeaderHidden: true,
          class: '',
          grids: [
            {
              title: '',
              isHeaderHidden: true,
              gridItems: [
                {
                  fields: [fileField],
                },
                {
                  fields: [filePreviewField],
                },
              ],
            },
          ],
        },
      },
    },
  };
};
